/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsService
 */

/**
 *  CHIRP definition of a business unit. See {@link BusinessUnit} for the full model.
 */

/**
 *  A user's default brand for a portal: either a specific brand
 *  ({@link #getDefaultBusinessUnitId()}) or all brands ({@link #getAllBrandsDefault()}).
 */

/**
 *  Sets the caller's default brand. This is a single either/or choice, not a list: set
 *  {@link #getBusinessUnitId()} to default to one specific brand, or set
 *  {@link #getAllBrandsDefault()} to {@code true} to default to all brands collectively —
 *  never both.
 */

export const getBusinessUnitsRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getBusinessUnits',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABJPsKJsEy6ii8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBusinessUnitsByUserRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getBusinessUnitsByUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABJPsKJsEy6ii8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBusinessUnitByIdRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getBusinessUnitById',
  auth: 'app',
  fingerprint: 'k0x-bN8romliylIDWjSKAy8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createBusinessUnitRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'createBusinessUnit',
  auth: 'app',
  fingerprint: '1XKFcV-3UdRiylIDWjSKAy8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBusinessUnitRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'updateBusinessUnit',
  auth: 'app',
  fingerprint: 'BGiAMChHajNiylIDWjSKAy8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteBusinessUnitRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'deleteBusinessUnit',
  auth: 'app',
  fingerprint: 'qexkAPIoGcowdTtUStoo3C8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserDefaultBusinessUnitRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getUserDefaultBusinessUnit',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACRh3A9bZ7U-S8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserDefaultBusinessUnitRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'setUserDefaultBusinessUnit',
  auth: 'app',
  fingerprint: 'wuyfijlM7YqhVq1CVimUDC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const clearUserDefaultBusinessUnitRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'clearUserDefaultBusinessUnit',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADw2f-_zZd8bC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPrimaryBrandIdRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'getPrimaryBrandId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAY1q-F1cS8si8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setPrimaryBrandIdRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsService',
  rpcName: 'setPrimaryBrandId',
  auth: 'app',
  fingerprint: 'GQ4hvuZUJoQY1q-F1cS8si8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};